var $d377f7c3f4968dab$export$7254cc27399e90bd = /*#__PURE__*/ function(State) {
    State["NotStarted"] = "not started";
    State["Running"] = "running";
    State["Paused"] = "paused";
    return State;
}({});
class $d377f7c3f4968dab$export$c57e9b2d8b9e4de {
    constructor(){
        this.state = "not started";
        this.priorSecondsElapsed = 0;
        this.timeStarted = null;
    }
    // the *Now methods take the current time so they can be tested (although
    // there are currently no tests)
    // seconds from just the ongoing run of the timer
    #lastRunSeconds(now) {
        if (this.timeStarted == null) {
            console.error(`unexpected call to lastRunSeconds with no timeStarted`);
            console.info(self);
            return 0;
        }
        const msElapsedThisRun = now.getTime() - this.timeStarted.getTime();
        return msElapsedThisRun / 1000;
    }
    // seconds the timer has tracked with the current time being now
    secondsElapsedNow(now) {
        if (this.state == "not started") return 0;
        else if (this.state == "paused") return Math.round(this.priorSecondsElapsed);
        else // this.state == State.Running
        return Math.round(this.priorSecondsElapsed + this.#lastRunSeconds(now));
    }
    secondsElapsed() {
        return this.secondsElapsedNow(new Date());
    }
    startNow(now) {
        if (this.state == "running") return;
        this.state = "running";
        this.timeStarted = now;
    }
    // start the timer
    start() {
        this.startNow(new Date());
    }
    // pause the timer's current run at the current time `now`
    pauseNow(now) {
        // if not even started we don't move into paused state
        if (this.state == "paused" || this.state == "not started") return;
        this.priorSecondsElapsed += this.#lastRunSeconds(now);
        this.state = "paused";
        this.timeStarted = null;
    }
    // pause the timer
    pause() {
        this.pauseNow(new Date());
    }
    // reset the timer completely
    reset() {
        this.state = "not started";
        this.priorSecondsElapsed = 0;
        this.timeStarted = null;
    }
    // time elapsed as short human-readable string
    elapsedText() {
        const totalSec = this.secondsElapsed();
        const hr = Math.floor(totalSec / 3600);
        const min = Math.floor(totalSec % 3600 / 60);
        const sec = totalSec % 60;
        if (hr > 0) {
            const minTwoDigit = min.toString().padStart(2, "0");
            return `${hr}:${minTwoDigit}`;
        } else {
            const secTwoDigit = sec.toString().padStart(2, "0");
            return `${min}:${secTwoDigit}`;
        }
    }
}


function $8cee4a6e11d14af2$export$83595b84fc78b9b4(id) {
    const el = document.getElementById(id);
    if (el == null) throw new Error(`dom element ${id} not found`);
    return el;
}
function $8cee4a6e11d14af2$export$36cf564d487b5178(s, minLength, padString) {
    var padding = "";
    while(padding.length + s.length < minLength)padding = padding + padString;
    return padding + s;
}


const $a923184d14019fc7$var$timer = new (0, $d377f7c3f4968dab$export$c57e9b2d8b9e4de)();
const $a923184d14019fc7$var$dom = {
    counters: (0, $8cee4a6e11d14af2$export$83595b84fc78b9b4)("counters"),
    hr: (0, $8cee4a6e11d14af2$export$83595b84fc78b9b4)("hr"),
    min: (0, $8cee4a6e11d14af2$export$83595b84fc78b9b4)("min"),
    sec: (0, $8cee4a6e11d14af2$export$83595b84fc78b9b4)("sec"),
    start_stop_btn: (0, $8cee4a6e11d14af2$export$83595b84fc78b9b4)("start_stop"),
    reset_btn: (0, $8cee4a6e11d14af2$export$83595b84fc78b9b4)("reset"),
    task: (0, $8cee4a6e11d14af2$export$83595b84fc78b9b4)("task")
};
function $a923184d14019fc7$var$updateDomTo(state) {
    const { totalSec: totalSec, task: task } = state;
    const hr = Math.floor(totalSec / 3600);
    const min = Math.floor(totalSec % 3600 / 60);
    const sec = totalSec % 60;
    if (hr > 0) {
        $a923184d14019fc7$var$dom.counters.classList.add("hr");
        $a923184d14019fc7$var$dom.counters.classList.remove("min");
        $a923184d14019fc7$var$dom.hr.textContent = `${hr}`;
        $a923184d14019fc7$var$dom.min.textContent = (0, $8cee4a6e11d14af2$export$36cf564d487b5178)(`${min}`, 2, "0");
    } else {
        $a923184d14019fc7$var$dom.counters.classList.add("min");
        $a923184d14019fc7$var$dom.counters.classList.remove("hr");
        $a923184d14019fc7$var$dom.min.textContent = `${min}`;
        $a923184d14019fc7$var$dom.sec.textContent = (0, $8cee4a6e11d14af2$export$36cf564d487b5178)(`${sec}`, 2, "0");
    }
    // set title text to include task and elapsed time
    var title = "Timer";
    const sep = "\xb7";
    if (task != "") title = `${task} ${sep} ${title}`;
    if (totalSec > 0 || $a923184d14019fc7$var$timer.state == (0, $d377f7c3f4968dab$export$7254cc27399e90bd).Running) title = `${$a923184d14019fc7$var$timer.elapsedText()} ${sep} ${title}`;
    document.title = title;
}
var $a923184d14019fc7$var$lastState = {
    totalSec: 0,
    task: ""
};
// Update the DOM based on the elapsed seconds.
function $a923184d14019fc7$var$updateTime() {
    const currentState = {
        totalSec: $a923184d14019fc7$var$timer.secondsElapsed(),
        task: $a923184d14019fc7$var$dom.task.innerText.trim()
    };
    if ($a923184d14019fc7$var$lastState.totalSec == currentState.totalSec && $a923184d14019fc7$var$lastState.task == currentState.task) // dom contents are already correct
    return;
    $a923184d14019fc7$var$lastState = currentState;
    $a923184d14019fc7$var$updateDomTo(currentState);
}
class $a923184d14019fc7$var$Updater {
    constructor(cb){
        this.cb = cb;
        this.intervalId = null;
    }
    stop() {
        if (this.intervalId != null) {
            clearInterval(this.intervalId);
            this.intervalId = null;
        }
    }
    start() {
        if (this.intervalId == null) this.intervalId = setInterval(this.cb, 200);
    }
}
const $a923184d14019fc7$var$updater = new $a923184d14019fc7$var$Updater($a923184d14019fc7$var$updateTime);
// update the DOM to reflect timer.state
function $a923184d14019fc7$var$updateDom() {
    if ($a923184d14019fc7$var$timer.state == (0, $d377f7c3f4968dab$export$7254cc27399e90bd).Running) {
        $a923184d14019fc7$var$dom.counters.classList.add("running");
        $a923184d14019fc7$var$updater.start();
        $a923184d14019fc7$var$dom.start_stop_btn.innerText = "pause";
    } else if ($a923184d14019fc7$var$timer.state == (0, $d377f7c3f4968dab$export$7254cc27399e90bd).NotStarted) {
        $a923184d14019fc7$var$updater.stop();
        $a923184d14019fc7$var$dom.counters.classList.remove("running");
        $a923184d14019fc7$var$dom.start_stop_btn.innerText = "start";
    } else {
        // timer.state == State.Paused
        $a923184d14019fc7$var$updater.stop();
        $a923184d14019fc7$var$dom.counters.classList.remove("running");
        $a923184d14019fc7$var$dom.start_stop_btn.innerText = "resume";
    }
    $a923184d14019fc7$var$updateTime();
}
function $a923184d14019fc7$var$start() {
    $a923184d14019fc7$var$timer.start();
    $a923184d14019fc7$var$updateDom();
}
function $a923184d14019fc7$var$pause() {
    $a923184d14019fc7$var$timer.pause();
    $a923184d14019fc7$var$updateDom();
}
function $a923184d14019fc7$var$reset() {
    $a923184d14019fc7$var$timer.reset();
    $a923184d14019fc7$var$updateDom();
}
$a923184d14019fc7$var$updateDom();
const $a923184d14019fc7$var$controller = {
    timer: $a923184d14019fc7$var$timer,
    start: $a923184d14019fc7$var$start,
    pause: $a923184d14019fc7$var$pause,
    reset: $a923184d14019fc7$var$reset,
    isRunning: ()=>{
        return $a923184d14019fc7$var$timer.state == (0, $d377f7c3f4968dab$export$7254cc27399e90bd).Running;
    },
    update: ()=>{
        $a923184d14019fc7$var$updateDom();
    }
};
var $a923184d14019fc7$export$2e2bcd8739ae039 = $a923184d14019fc7$var$controller;



const $4b9a876709dc98c4$var$dom = {
    start_stop_btn: (0, $8cee4a6e11d14af2$export$83595b84fc78b9b4)("start_stop"),
    reset_btn: (0, $8cee4a6e11d14af2$export$83595b84fc78b9b4)("reset"),
    task: (0, $8cee4a6e11d14af2$export$83595b84fc78b9b4)("task")
};
/// Set up task/window hash UI.
function $4b9a876709dc98c4$var$hashToTask(hash) {
    if (!hash) return "";
    var text = decodeURI(hash);
    if (text[0] == "#") text = text.substring(1, text.length);
    return text;
}
function $4b9a876709dc98c4$var$loadWindowHash() {
    $4b9a876709dc98c4$var$dom.task.innerText = $4b9a876709dc98c4$var$hashToTask(window.location.hash);
}
// on initial document load
$4b9a876709dc98c4$var$loadWindowHash();
// when hash is changed by user
window.addEventListener("hashchange", $4b9a876709dc98c4$var$loadWindowHash);
$4b9a876709dc98c4$var$dom.task.addEventListener("focusout", (_e)=>{
    window.location.hash = $4b9a876709dc98c4$var$dom.task.innerText;
    (0, $a923184d14019fc7$export$2e2bcd8739ae039).update();
});
/// Set up timer UI.
function $4b9a876709dc98c4$var$startStop() {
    if ((0, $a923184d14019fc7$export$2e2bcd8739ae039).isRunning()) (0, $a923184d14019fc7$export$2e2bcd8739ae039).pause();
    else (0, $a923184d14019fc7$export$2e2bcd8739ae039).start();
}
$4b9a876709dc98c4$var$dom.start_stop_btn.addEventListener("click", (_e)=>{
    $4b9a876709dc98c4$var$startStop();
});
function $4b9a876709dc98c4$var$reset() {
    (0, $a923184d14019fc7$export$2e2bcd8739ae039).reset();
}
$4b9a876709dc98c4$var$dom.reset_btn.addEventListener("click", (_e)=>{
    $4b9a876709dc98c4$var$reset();
});
function $4b9a876709dc98c4$var$startEditing() {
    $4b9a876709dc98c4$var$dom.task.focus();
    const sel = window.getSelection();
    if (!sel) return;
    // reset selection to front
    sel.collapseToStart();
    // select entire task input
    sel.modify("extend", "right", "line");
}
// Keyboard shortcuts
document.onkeydown = (e)=>{
    // editable task field
    if (e.target == $4b9a876709dc98c4$var$dom.task) {
        if (e.key == "Enter") {
            $4b9a876709dc98c4$var$dom.task.blur();
            // stop event from propagating (that is, from adding a newline to text
            // field)
            return false;
        }
        return;
    }
    const shortcuts = new Map([
        [
            " ",
            $4b9a876709dc98c4$var$startStop
        ],
        [
            "r",
            $4b9a876709dc98c4$var$reset
        ],
        [
            "p",
            (0, $a923184d14019fc7$export$2e2bcd8739ae039).pause
        ],
        [
            "e",
            $4b9a876709dc98c4$var$startEditing
        ]
    ]);
    // pass through keys with modifiers (needed so cmd-r to reload works, for
    // example)
    if (e.ctrlKey || e.metaKey || e.altKey || e.shiftKey) return true;
    const cb = shortcuts.get(e.key);
    if (cb) {
        cb();
        return false;
    }
};


//# sourceMappingURL=web-timer.12bee5a8.js.map
